import { reactive } from 'vue';

import bg1 from '@/assets/images/bg-1.png';
import bg2 from '@/assets/images/bg-2.png';
import bg3 from '@/assets/images/bg-3.png';
import bg4 from '@/assets/images/bg-4.png';
import bg5 from '@/assets/images/bg-5.png';
import bg6 from '@/assets/images/bg-6.png';
import bg7 from '@/assets/images/bg-7.png';
import nft11 from '@/assets/images/s1-1.gif';
import nft12 from '@/assets/images/s1-2.gif';
import nft13 from '@/assets/images/s1-3.gif';
import nft14 from '@/assets/images/s1-4.gif';

import nft21 from '@/assets/images/s2-1.gif';
import nft22 from '@/assets/images/s2-2.gif';
import nft23 from '@/assets/images/s2-3.gif';
import nft24 from '@/assets/images/s2-4.gif';

import nft31 from '@/assets/images/s3-1.gif';
import nft32 from '@/assets/images/s3-2.gif';
import nft33 from '@/assets/images/s3-3.gif';
import nft34 from '@/assets/images/s3-4.gif';

import nft41 from '@/assets/images/s4-1.gif';
import nft42 from '@/assets/images/s4-2.gif';
import nft43 from '@/assets/images/s4-3.gif';
import nft44 from '@/assets/images/s4-4.gif';
import nft51 from '@/assets/images/s5-1.gif';
import nft61 from '@/assets/images/s6-1.gif';
import nft71 from '@/assets/images/s7-1.gif';

export type GifDisplayType = {
    url: string;
    isShow: boolean;
    isLoaded: boolean;
    isImgLoaded: boolean;
    imgLoadPromise: Promise<void>;
    _img: HTMLImageElement;
}

export const getGifList = () => {
    // [STAGE][SYNTH_TYPE]
    const map = [
        [nft11, nft12, nft13, nft14],
        [nft21, nft22, nft23, nft24],
        [nft31, nft32, nft33, nft34],
        [nft41, nft42, nft43, nft44],
    ].reduce((acc, curr, idx) => {
        loadBg(idx + 1);
        const list: GifDisplayType[] = curr.map((url) => {
            const img = new Image();
            const data: GifDisplayType = {
                url,
                isShow: false,
                isLoaded: false,
                isImgLoaded: false,
                _img: img,
                imgLoadPromise: new Promise((resolve) => {
                    img.onload = () => {
                        data.isImgLoaded = true;
                        resolve();
                    };
                }),
            };
            img.src = url;

            return data;
        });
        acc.push(list);
        return acc;
    }, [] as Array<GifDisplayType[]>);
    map[0][0].isShow = true;
    return map;
};

// export const GifImageList = reactive(getGifList());

// export const bgList = [bg5, bg5, bg5, bg5, bg6, bg7].map((item) => {
//     const img = new Image();
//     img.src = item;
//     return img;
// });

export function loadBg(synth: number) {
    const img = new Image();
    switch (synth) {
        case 1:
            img.src = bg1;
            break;
        case 2:
            img.src = bg2;
            break;
        case 3:
            img.src = bg3;
            break;
        case 4:
            img.src = bg4;
            break;
        case 5:
            img.src = bg5;
            break;
        case 6:
            img.src = bg6;
            break;
        case 7:
            img.src = bg7;
            break;
        default:
            break;
    }
    return img;
}

export function getGifItem(synth: number) {
    loadBg(synth);
    let url = nft11;
    switch (synth) {
        case 1:
            url = nft11;
            break;
        case 2:
            url = nft21;
            break;
        case 3:
            url = nft31;
            break;
        case 4:
            url = nft41;
            break;
        case 5:
            url = nft51;
            break;
        case 6:
            url = nft61;
            break;
        case 7:
            url = nft71;
            break;
        default:
            break;
    }
    const img = new Image();
    const data: GifDisplayType = {
        url,
        isShow: true,
        isLoaded: false,
        isImgLoaded: false,
        _img: img,
        imgLoadPromise: new Promise((resolve) => {
            img.onload = () => {
                data.isImgLoaded = true;
                resolve();
            };
        }),
    };
    img.src = url;

    return data;
}
